import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Bullets } from './components/Bullets';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-abyss font-body text-bone" data-id="element-0" data-mp="31aqeac69cmp5">
      <TopBar data-id="element-1" data-mp="31c9vc4zqn1rz" />
      <Hero data-id="element-2" data-mp="31c1iue7j1yhb" />
      <main data-id="element-3" data-mp="31cjnnz899l0u">
        <Problem data-id="element-4" data-mp="2wk0av4he6tx3" />
        <Offer data-id="element-5" data-mp="2wjgq7g0cxrfd" />
        <Solution data-id="element-6" data-mp="2wiywor52xrb5" />
        <Bullets data-id="element-7" data-mp="2wifh3h2wjf0a" />
        <Guarantee data-id="element-8" data-mp="2whxabqim5ie4" />
      </main>
      <Footer data-id="element-9" data-mp="28tw6guwdqq51" />
      <StickyCta data-id="element-10" data-mp="28tmej1rry8wp" />
    </div>;
}